import { render, staticRenderFns } from "./ProponentProfile.vue?vue&type=template&id=c9d348ea&scoped=true"
import script from "./ProponentProfile.vue?vue&type=script&lang=js"
export * from "./ProponentProfile.vue?vue&type=script&lang=js"
import style0 from "./ProponentProfile.vue?vue&type=style&index=0&id=c9d348ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d348ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d348ea')) {
      api.createRecord('c9d348ea', component.options)
    } else {
      api.reload('c9d348ea', component.options)
    }
    module.hot.accept("./ProponentProfile.vue?vue&type=template&id=c9d348ea&scoped=true", function () {
      api.rerender('c9d348ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/ProponentProfile.vue"
export default component.exports